import React, { useState } from "react";
import "./Slider.css";
const Slider = ({ label, value, handleChange, min, max, step }) => {
  const [localValue, setLocalValue] = useState(value);
const percentage = ((value - min) / (max - min)) * 100;

  const handleRangeChange = (e) => {
    const numericValue = parseFloat(e.target.value);
    setLocalValue(numericValue);
    handleChange(numericValue);
  };

  const handleInputChange = (e) => {
    const { value: inputValue } = e.target;

    // Allow empty input while typing
    if (inputValue === "") {
      setLocalValue("");
      return;
    }

    // Allow only numbers and decimal
    if (!/^\d*\.?\d*$/.test(inputValue)) return;

    const numericValue = Number(inputValue);

    if (numericValue < min || numericValue > max) return;

    setLocalValue(numericValue);
    handleChange(numericValue);
  };

  return (
    <>
      {/* <div className="slider" style={{width:'90%',}}>
        <input
          type="range"
          value={value}
          onChange={(evt) => handleChange(evt.target.value)}
        />
        <input
          min='0'
          max={100}
          type="number"
          value={value}
          onChange={(evt) => handleChange(evt.target.value)}
        />
        <span>Px</span>
      </div> */}

      {["Ragged Gutter", "Gutter"].includes(label) && (
        <div className="flex justify-between items-center sliderBox w-full ">
          <div className="sliderLabel w-[20%] inline-block text-right group cursor-help underline decoration-dashed decoration-[rgba(255,255,255,0.4)] underline-offset-4">
            <span className="cursor-help ">Gutter</span>
            <span className="absolute hidden group-hover:block cursor-help ml-[-50px] mt-[-100px]  p-2 rounded-xl bg-[#191824] text-[#eee9ff] border-[1px] border-[rgba(255,255,255,0.1)] text-xs shadow-xl w-[200px] max-w-[200px] text-center">
              Adjust the padding space on the left and right sides of the credit
              canvas.
            </span>
          </div>
          <div className="w-[50%] flex items-center">
            <input
              type="range"
              min={min}
              max={max}
              step={step}
              value={value}
              onChange={handleRangeChange}
              className=" max-w-full"
              style={{
                background: `linear-gradient(
                  to right,
                  #7c5cff 0%,
                  #7c5cff ${percentage}%,
                  rgba(255,255,255) ${percentage}%,
                  rgba(255,255,255) 100%
                )`,
              }}              
            />
          </div>
          <span className="text-[13.5px] leading-4 text-white font-body">{value}px</span>
          {/* <div className="w-[35%] h-full flex justify-evenly items-center resize-none bg-[#ffffff0b] outline-none border-[#ffffff14] border rounded-xl text-[#f0eeff] px-[6px] py-[4px] font-normal text-[13px]">
          <input
            type="number"
            value={value}
            onChange={handleInputChange}
            className="text-[#f6f2ff] px-1 w-[50%] py-1 rounded text-center bg-transparent focusN focus:border-transparent focus:outline-none"
          />

          <span className="w-[40%]"></span>
        </div> */}
        </div>
      )}
    </>
  );
};

export default Slider;
